export const CONTROL_DOCUMENT_ALLOWED_MIME_TYPES = [
  'application/msword',
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'audio/mpeg',
  'image/bmp',
  'image/gif',
  'image/jpeg',
];

// DMS control documents: the generated XML embeds the raw file as base64
// (inflating the size by 4/3) and must not exceed 20 MB per message.
// A 15 MB raw file becomes ~20 MB of base64 in the resulting XML.
export const MAX_CONTROL_DOCUMENT_SIZE = 15 * 1024 * 1024; // 15 MB
